import styled from 'styled-components';

export const IframeContainer = styled.iframe`
  width: 100%;
  height: 100%;
  position: absolute;
  left:  0;
  top: 0;
`;



